import firebase from 'firebase/app'
import 'firebase/firestore'
const ASSESSMENTS = 'odourAssessments';
const TEST_ASSESSMENTS = "testOdourAssessments";

function getDb() {
    const db = firebase.firestore()
    const settings = { timestampsInSnapshots: true };
    db.settings(settings);
    return db;
}

export function saveAssesment(assessment) {
    // Intensity data should be send from 0 to 6 and not from 1 to 7
    assessment.intensity = assessment.intensity - 1

    if (process.env['REACT_APP_FAKE_BACKEND']) {
        console.warn('REACT_APP_FAKE_BACKEND feature toggle is on')
        console.warn('FAKE BACKEND REQUEST:', assessment);
        return Promise.all([
            testSaveFirebaseAssessment(assessment)
        ])
    }

    return Promise.all([
        saveFirebaseAssessment(assessment)
    ])
}

export function testSaveFirebaseAssessment(assessment) {
    const db = getDb()
    const { location, ...rest } = assessment
    const place = new firebase.firestore.GeoPoint(location.geometry.lat, location.geometry.lng)
    return db.collection(TEST_ASSESSMENTS).add({ ...rest, location: place, formatted_address: location.formatted_address, createdAt: new Date() })
}

export function saveFirebaseAssessment(assessment) {
    const db = getDb()
    const { location, ...rest } = assessment
    const place = new firebase.firestore.GeoPoint(location.geometry.lat, location.geometry.lng)
    return db.collection(ASSESSMENTS).add({ ...rest, location: place, formatted_address: location.formatted_address, createdAt: new Date() })
}
